import React from "react";

const ProgressBar = ({ currentIndex, total }) => {
  const percentage = ((currentIndex + 1) / total) * 100;

  return (
    <div className="progress-bar-bg">
      <div
        className="progress-bar-fill"
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;
